import type * as FullWidthPromoWithCards from '../types/FullWidthPromoWithCards'
import { imageParser } from '../props/parsers/Image'

export default function fullWidthPromoWithCardsComponentParser(
  rawComponent: FullWidthPromoWithCards.Raw,
): FullWidthPromoWithCards.Parsed {
  const {
    image,
    bodyText,
    headlineText,
    cards,
  } = rawComponent.fullWidthPromoWithCards

  return {
    name: 'FullWidthPromoWithCards',
    props: {
      mainInfo: {
        bodyText,
        headlineText,
      },
      cards: cards.map(({ image, headlineText, bodyText }) => ({
        bodyText,
        headlineText,
        ...imageParser(image),
      })),
      ...imageParser(image),
    },
  }
}

// static FullWidthPromoWithCards(name, props) {
//   const { bodyText, headlineText, ...rest } = props

//   return [
//     {
//       name,
//       props: {
//         ...PropParser.format(rest),
//         mainInfo: {
//           bodyText,
//           headlineText,
//         },
//       },
//     },
//   ]
// }
